

























































import { Component, Vue } from "vue-property-decorator";
import imgModal from "./imgModal.vue";

@Component({
  components: {
    imgModal,
  },
})
export default class Home extends Vue {
  public modal = false;
  public detail: any = [];
  public limit = 0;
  public show(row) {
    this.detail = row;
    this.modal = true;
  }

  // 图片弹窗
  public showImg(item) {
    const $imgModal: any = this.$refs.imgModal;
    $imgModal.show(item);
  }
}
